import { render, staticRenderFns } from "./filtro.vue?vue&type=template&id=ed86b85a"
import script from "./filtro.vue?vue&type=script&lang=js"
export * from "./filtro.vue?vue&type=script&lang=js"
import style0 from "./filtro.vue?vue&type=style&index=0&id=ed86b85a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports